import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { roomInfoLS } from 'client/utils';
import { ROOM_STATUS } from 'constants/index';
import { setRoomStatus } from 'client/redux/room';
import { setIsBroadcasting } from 'client/redux/mux-details';

import { SystemChannelMetaDataCustom } from '../../types';
import { PB_CHANNELS } from '../../constants';
import { getErrorText } from '../helpers';
import { RootState } from '../../..';

type Params = { roomId: string };
type Response = Pubnub.GetChannelMetadataResponse<SystemChannelMetaDataCustom>;

export const getSystemChannelMetadata = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/getSystemChannelMetadata',
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;
      const lsRoomInfo = roomInfoLS.getData(data.roomId);

      if (pubnubReducer.pubnub) {
        const result: Pubnub.GetChannelMetadataResponse<SystemChannelMetaDataCustom> =
          await pubnubReducer.pubnub.objects.getChannelMetadata({
            channel: `${data.roomId}.${PB_CHANNELS.SYSTEM}`,
          });
        const isBroadcasting = result.data.custom?.isBroadcasting || false;

        dispatch(setIsBroadcasting(isBroadcasting));
        dispatch(setRoomStatus(result.data.custom?.roomStatus || ROOM_STATUS.INACTIVE));

        if (!isBroadcasting && lsRoomInfo?.isStartBroadcastByMe) {
          roomInfoLS.setData(data.roomId, { isStartBroadcastByMe: false });
        }

        return result;
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
